import moment from 'moment'
import { createSelector } from 'reselect'

import Cookies from 'utils/GoustoCookies'
// eslint-disable-next-line import/no-cycle
import { get } from 'utils/cookieHelper2'
import { getSlotTimes } from 'utils/deliveries'
import { parsePhoneNumber } from 'utils/phoneNumber/phoneNumber'

export const getCheckoutUrgency = ({ checkoutUrgency }) => checkoutUrgency

export const getCheckoutUrgencyCurrentStatus = createSelector(
  getCheckoutUrgency,
  (checkoutUrgency) => checkoutUrgency.get('currentStatus'),
)

export const getRecaptchaExecutionStarted = (state) =>
  state.checkout.get('recaptchaExecutionStarted')

export const getApplePayRecaptchaExecutionStarted = (state) =>
  state.checkout.get('applePayRecaptchaExecutionStarted')

export const hasCheckoutError = (state) => {
  const errors = state.checkout.get('errors')
  if (!errors) {
    return false
  }

  return errors.filter((error) => error).size > 0
}

export const accountFormName = 'account'
export const deliveryFormName = 'delivery'

export const getFormattedPhoneNumber = (phone) => {
  const parsedPhone = parsePhoneNumber(phone, 'GB')

  return parsedPhone ? parsedPhone.formatNational().replace(/\s/g, '') : ''
}

export const getPasswordValue = (state) => state.checkout.getIn(['passwordInfo', 'value'])

export const getFeLoggingCorrelationData = (state) => ({
  session_id: get(Cookies, 'gousto_session_id', false, false),
  gousto_ref: state.checkout.get('goustoRef'),
})

export const getSignupE2ETestName = ({ features }) =>
  features && features.getIn(['signupE2ETestName', 'value'], '')

/**
 * Returns true if Apple Pay is enabled in browser and supported by Apple Pay API
 */
export const getIsApplePayEnabled = (state) => state.checkout.get('isApplePayEnabled')

export const getDeliveryTimeAndDate = (state) => {
  const deliveryDays = state.boxSummaryDeliveryDays
  const date = state.basket.get('date')
  const slotId = state.basket.get('slotId')

  const deliveryDate = moment(date).format('dddd Do MMMM')
  const deliveryTime = getSlotTimes({ date, deliveryDays, slotId })

  return {
    deliveryDate,
    deliveryTime,
  }
}

export const getApplePayDeliveryInstruction = (state) =>
  state.checkout.getIn(['applePay', 'deliveryInstruction'])

export const getApplePayDeliveryInstructionCustom = (state) =>
  state.checkout.getIn(['applePay', 'deliveryInstructionCustom'])

export const getApplePayDeliveryAddress = (state) =>
  state.checkout.getIn(['applePay', 'deliveryAddress']).toJS()

export const getApplePayPersonalInfo = (state) =>
  state.checkout.getIn(['applePay', 'personalInfo']).toJS()

export const getGoustoRef = (state) => state.checkout.get('goustoRef')
